export const FILE_TYPES = {
  JPG: {
    NAME: "JPG",
    MIME: "image/jpeg",
  },
  PDF: {
    NAME: "PDF",
    MIME: "application/pdf",
  },
  PNG: {
    NAME: "PNG",
    MIME: "image/png",
  },
  ICO: [
    {
      NAME: "ICO",
      MIME: "image/vnd.microsoft.icon",
    },
    {
      MIME: "image/x-icon",
    },
  ],
  SVG: {
    NAME: "SVG",
    MIME: "image/svg+xml",
  },
};
